import { render } from "./notation.vue?vue&type=template&id=84d640be"
import script from "./notation.vue?vue&type=script&lang=js"
export * from "./notation.vue?vue&type=script&lang=js"

import "./notation.vue?vue&type=style&index=0&id=84d640be&lang=scss"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__